export default __webpack_public_path__ + "images/down-arrow.svg";